module.exports = __webpack_public_path__ + "img/icon-clock.65201f36.svg";